import { Link } from "react-router-dom";
import { BasicPageContainer } from "components/views/BasicPageContainer";
import { RoutePaths } from "constants/RoutePaths";
import { useTranslation } from "react-i18next";

export const UnauthorizedPage = () => {
    const {t} = useTranslation();
    
    return <BasicPageContainer>
        <div>{t("unauthorizedPage.text")}</div>
        <div>
            <Link to={RoutePaths.HOME}>{t("unauthorizedPage.link")}</Link>
        </div>
    </BasicPageContainer>;
};